module.exports = __webpack_public_path__ + "static/media/req-delivery.0a049325.svg";